import {Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {AppUpdateService} from './shared/services/helpers/app-update.service';
import {ToastsComponent} from './shared/components/toasts/toasts.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet, ToastsComponent]
})
export class AppComponent {
  constructor(
    private appUpdateSvc: AppUpdateService
  ) {
    this.appUpdateSvc.start()
  }
}
